<template>
  <v-app>
    <v-container>
      <v-dialog
        v-model="askForAccess"
        max-width="500px"
      >
        <v-card>
          <v-card-title
            class="headline"
          >
            Нэвтрэx
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col
                  cols="12"
                >
                  <v-text-field
                    v-model="username"
                    color="purple darken-2"
                    label="Нэвтрэx нэр"
                    required
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  cols="12"
                >
                  <v-text-field
                    v-model="passwrd"
                    color="purple darken-2"
                    label="Нууц үг"
                    required
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        
          <v-card-actions class="justify-center">
            <v-btn
              color="green darken-1"
              class="white--text px-10  mb-10"
              style="min-width: 0;"
              @click="_checkAccess"
            >
              Нэвтрэx
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </v-app>
</template>
<script>
  const fb = require('../../firebaseConfig.js')
  export default {
    name: 'ViewAccessQ',
    // mixins: [utils],
    props: {
      asuulgaId: {
        type: String,
        required: false,
      },
      userId: {
        type: String,
        required: false,
      },
    },
    data: () => ({
      askForAccess: true,
      color: '#ccc',
      username: null,
      passwrd: null,
      accessOK: false,

    }),
    computed: {
    },
    created() {
   
    },
    methods: {
      accessRoom(){
        this.askForAccess = true
      },
      _viewQuestion() {
        this.$router.push({ name: 'AnswerQuestionaire', params: { asuulgaId: this.asuulgaId } })
      },
      async _checkAccess(){
        var datas = await fb.db
          .collection("asuulga/" + this.asuulgaId + "/users")
          .where("register", "==", this.username).where("phone", "==", this.passwrd)
          .limit(1)
          .get()
        if (!datas.empty) {
          this.accessOK = true
          this._viewQuestion()
          this.askForAccess = false
          // viewquestions/VFMYBMmCkNJ9dBZsuN8Q
        } else {
          this.accessOK = false
        }
      },
    },
  }
</script>
